import React from 'react';
import {CheckBox} from "./CheckBox";

interface CheckBoxSetOption {
    value: number;
    label: string;
    inactive?: boolean;
}

interface CheckBoxSetProps {
    options: CheckBoxSetOption[];
    values: number[];
    onChange: Function;
}

export let CheckBoxSet = function (props: CheckBoxSetProps) {
    let checkedIds = props.values || [];

    function onChangeOption(option: CheckBoxSetOption, checked: boolean) {
        let updatedCheckedIds;
        if (checked) {
            updatedCheckedIds = [...checkedIds, option.value];
        } else {
            updatedCheckedIds = checkedIds.filter((checkedId) => checkedId !== option.value);
        }
        props.onChange(updatedCheckedIds);
    }

    return (
        <div className="common-form-checkbox-set">
            {props.options.map((option) => (
                <CheckBox
                    key={option.value}
                    id={`checkBoxSetOption-${option.value}`}
                    checked={checkedIds.includes(option.value)}
                    onChange={(checked: boolean) => onChangeOption(option, checked)}
                    label={option.label}
                    inactive={option.inactive}
                />
            ))}
        </div>
    );
};
